import { action, computed, makeObservable, observable } from 'mobx';
import { AwardedNomination, NominationPermissions, NominationSummary } from '../../models';

export class NominationDashboardPageUiStore {
  @observable nominationSummaries: NominationSummary[] = [];

  @observable awardedNominations: AwardedNomination[] = [];

  @observable nominationPermissions = new Map<number, NominationPermissions>();

  @observable isLoadingNominationPermissions = new Map<number, boolean>();

  constructor() {
    makeObservable(this);
  }

  @action
  setNominationSummaries(summaries: NominationSummary[]): void {
    this.nominationSummaries = summaries;
  }

  @action
  setAwardedNominations(nominations: AwardedNomination[]): void {
    this.awardedNominations = nominations;
  }

  @action
  setNominationPermissions(nominationId: number, permissions: NominationPermissions): void {
    this.nominationPermissions.set(nominationId, permissions);
  }

  @action
  setIsLoadingNominationPermissions(nominationId: number, isLoading: boolean): void {
    this.isLoadingNominationPermissions.set(nominationId, isLoading);
  }

  @computed
  get hasNominationPermission(): (nominationId: number) => boolean {
    return (nominationId: number): boolean => this.nominationPermissions.has(nominationId);
  }

  @computed
  get isLoadingNominationPermission(): (nominationId: number) => boolean {
    return (nominationId: number): boolean => this.isLoadingNominationPermissions.get(nominationId) ?? false;
  }

  @action
  resetStates(): void {
    this.nominationSummaries = [];
    this.awardedNominations = [];
    this.nominationPermissions = new Map();
    this.isLoadingNominationPermissions = new Map();
  }
}
